import { ConditionalContent, DynamicContent } from 'modules/dynamicContentBuilder/domain';

export const isConditionalContent = (
  content: DynamicContent | null,
): content is ConditionalContent =>
  !!content && 'ifClause' in content && 'defaultContent' in content;
